import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { LoaderDotComponent } from '../loader-dot/loader-dot.component';

@Component({
  standalone: true,
  selector: 'base-listing-loader',
  templateUrl: './listing-loader.component.html',
  styleUrls: ['./listing-loader.component.scss'],
  imports: [CommonModule, LoaderDotComponent]
})
export class ListingLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}

